<script>
    import ForgotPassword from '/public/components/users/ForgotPassword.svelte';
</script>

<main>
    <div class="row justify-content-center mt-3 mb-3">
        <div class="col-sm-10 col-md-6 col-lg-4">
            <ForgotPassword/>
        </div>
    </div>
</main>
